<template>
  <div class='containerLogin'>           
    <div class="panel panel-primary">
        <div class="panel-heading">Entra con tu cuenta</div>
        <div class="panel-body">                                                          
            <div class="input-group form-group">
              <span class="input-group-addon"><span class='glyphicon glyphicon-user glyphicon-tamano'></span></span>
						  <input type="text" tabindex="2" class="form-control" placeholder="Usuario"  v-model='newUser.username'>
						</div>
            <div class="input-group form-group">
              <span class="input-group-addon"><span class='glyphicon glyphicon-lock glyphicon-tamano'></span></span>
						  <input type="password" tabindex="2" class="form-control" placeholder="Clave"  v-model='newUser.password'>
						</div>            
            <button class="btn btn-primary btn-block" @click='validateFields'>Iniciar Session</button>            
        </div>
    </div>    
    <hr>           
    <Register></Register>
  </div>
</template>

<script>
import { eventBus } from '../../main';
export default {  
  data: function () {     
    return {
        newUser:{          
          username:'',
          password:'',          
        }       
    }
  },
  mounted: function () {        
       
  },
  methods: {
    validateFields: function(){
      
      eventBus.$emit('hide');

      if(this.newUser.username.length == 0){        
        eventBus.$emit('genericMessage', false, "Favor llenar 'Usuario'");
        return;
      }

      if(this.newUser.password.length == 0){        
        eventBus.$emit('genericMessage', false, "Favor llenar 'Clave'");
        return;
      }

      this.$http.post('api/login', this.newUser ).then(response => {                                                                  
        eventBus.$emit('genericMessage', response.body.status , response.body.msg);            
        if(response.body.status == 1) {          
          this.$router.push('/');	        
          this.$router.go('');	        
        }
        
      }, response => {                  
        eventBus.$emit('errorMsg', response);          
      });

    },
  },
  filters: {
     
  },
  computed: {
    
  }
}
</script>

<style scoped> 

  @media screen and (min-width: 0px) {  
      
   }

  @media screen and (max-width: 981px) {  
      .containerLogin {  
        font-size: 4em;            
      }       

      .glyphicon-tamano {
        font-size: 3em;
      }

      input {        
        position:relative;
        width:100%;
        height:100px;
        font-size: 0.8em;            
      }

      button {        
        position:relative;
        width:100%;
        height:100px;
        font-size: 0.8em;            
      }
   }

  @media screen and (min-width: 981px) {          
      .containerLogin {        
        font-size: 1.4em;    
        width: 400px;
      }

      button {               
        font-size: 1.2em;            
      }     

      input {               
        font-size: 1em;            
      }       
   }

</style>



// WEBPACK FOOTER //
// Login.vue?ecc58bde